module.exports = __webpack_public_path__ + "img/hcdl_detail.efb79727.jpg";